export default {"src":"/_next/static/media/wise_logo.44c8dc7c.svg","height":66,"width":290,"blurWidth":0,"blurHeight":0};